import { Component, OnInit, ViewChild } from '@angular/core';

import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { BookingModel, BookingService, CustomersService, PasswordReset, RecentBookings, UpdateCustomer, UpdateVehicle, UsersService, VehiclesService, UpdateAgentModel, UpdateAgencyModel, AgenciesService, GetAllAgenciesResult, UserModel } from 'src/app/Api_Module';
import { FindCustomerResult } from '../../../Api_Module';
import { titles } from '../../../models/constants.model';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'crg-agent-dash',
  templateUrl: './agent-dash.component.html'
})
export class AgentDashComponent implements OnInit {

  @ViewChild('bookingsTable') table: DatatableComponent;

  bookings: BookingModel[] = [];
  cache: BookingModel[] = [];
  recentBookings: RecentBookings[] = [];
  searchStr: string;
  filtervalue: string;
  alert: any;
  loading: boolean;
  agency: GetAllAgenciesResult;
  agent: UpdateAgentModel;
  user: UserModel;
  password: string;
  confirmPassword: string;

  messagesAgents = { emptyMessage: 'No Agent found. Try different parameters', totalMessage: 'Total Agents' };

  messages = {emptyMessage: 'No Bookings found. Try different parameters', totalMessage: 'Total Bookings'};

  titles: string[];

  constructor(public authServc: AuthenticationService, private agenciesSrvc: AgenciesService, private bookingService: BookingService,
              private toastr: ToastrService, private vehicleSrvc: VehiclesService, private usersSrvc: UsersService) {
  }

  ngOnInit() {
    this.getAgencyFromId();
    this.loading = true;
    this.titles = titles;
    this.user = this.authServc.userObj();
  }

  getAgencyFromId() {
    this.agenciesSrvc.getAgency(this.authServc.getAgencyId()).subscribe((resp: GetAllAgenciesResult) => {
        this.loading = false;
        if (!!resp) {
          this.agency = resp;
        }
      },
      error => {
        this.loading = false;
        if (error[ 'status' ] === 404) {
          this.toastr.warning('Agency Details Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  deleteAgent(agentId) {
    this.loading = true;
    this.agenciesSrvc.deleteAgent(agentId).subscribe((resp) => {
      this.loading = false;
      this.toastr.success('Agent Deleted.');
      this.getAgencyFromId();
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
    // this.toastr.warning('Not Impletement Yet');
    this.loading = false;
  }

  saveAgency() {
    const updateAgency: UpdateAgencyModel = this.agency;
    this.agenciesSrvc.putAgency(this.agency.id, updateAgency).subscribe((resp: any) => {
        this.loading = false;
        this.toastr.success('Details updated!');
      },
      error => {
        this.loading = false;
        if (error[ 'status' ] === 404) {
          this.toastr.warning('Agency Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  saveUser() {
    this.usersSrvc.put(this.user).subscribe((resp: any) => {
      this.loading = false;
      this.toastr.success('Details updated!');
      localStorage.setItem('currentUser', JSON.stringify(this.user));
    },
    error => {
      this.loading = false;
      if (error[ 'status' ] === 404) {
        this.toastr.warning('Agency Not Found!');
      } else {
        this.toastr.error('Something went wrong please try again later!');
      }
      console.log('error:' + JSON.stringify(error));
    });
  }

  checkPasswords() {
    return this.password === this.confirmPassword;
  }

  changePassword() {
    const passwordreset: PasswordReset = {userId: this.authServc.getUserId(), password: this.password};
    this.usersSrvc.reset(passwordreset).subscribe((resp: FindCustomerResult) => {
        this.loading = false;
        this.toastr.success('Password updated!');
        this.password = '';
        this.confirmPassword = '';
      },
      error => {
        this.loading = false;
        if (error[ 'status' ] === 404) {
          this.toastr.warning('Customer Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

    close(alert: any) {
    // this.alert = null;
  }
}
